import { Reducer } from 'redux';

export interface FlowDialogState {
  step: number;
  buttonDisabled?: boolean;
  callbackFn?: () => void;
  isProcessing: boolean;
  isCompleted?: boolean;
}

export interface SetStepAction {
  type: 'SET_STEP';
  step: number;
}

export interface DisableButtonAction {
  type: 'DISABLE_BUTTON';
  disabled: boolean;
}

export interface SetCallbackAction {
  type: 'SET_CALLBACK';
  callbackFn: () => void;
}

export interface SetIsProcessing {
  type: 'SET_IS_PROCESSING';
  isProcessing: boolean;
}

export interface SetFlowCompleted {
  type: 'SET_FLOW_COMPLETED';
}

export interface ClearFlowCompleted {
  type: 'CLEAR_FLOW_COMPLETED';
}

type FlowDialogActionTypes =
  | SetStepAction
  | SetCallbackAction
  | DisableButtonAction
  | SetIsProcessing
  | SetFlowCompleted
  | ClearFlowCompleted;

const flowDialogReducer: Reducer<FlowDialogState, FlowDialogActionTypes> = (
  state: FlowDialogState | undefined,
  incomingAction: FlowDialogActionTypes,
): FlowDialogState => {
  if (state === undefined) {
    return { step: 1, isProcessing: false };
  }
  const action = incomingAction;

  switch (action.type) {
    case 'SET_STEP':
      return {
        ...state,
        step: action.step,
        buttonDisabled: false,
        isProcessing: false,
        isCompleted: false,
      };
    case 'SET_CALLBACK':
      return {
        ...state,
        callbackFn: action.callbackFn,
      };
    case 'DISABLE_BUTTON':
      return {
        ...state,
        buttonDisabled: action.disabled,
      };
    case 'SET_IS_PROCESSING':
      return {
        ...state,
        isProcessing: action.isProcessing,
      };
    case 'SET_FLOW_COMPLETED':
      return {
        ...state,
        isProcessing: false,
        isCompleted: true,
      };
    case 'CLEAR_FLOW_COMPLETED':
      return {
        ...state,
        isCompleted: false,
      };
    default:
      return state;
  }
};

export { flowDialogReducer };
